import { useObservable } from 'state/observable/observable.state.hook';
import { popupStateService } from 'state/popup.state.service';

export const usePopupState = () => {
  return {
    popupOffers: useObservable(popupStateService.popupOffers),
    currentPopupDisplayed: useObservable(popupStateService.currentPopupDisplayed),
    dailyBonusBadgesNextDate: useObservable(popupStateService.dailyBonusBadgesNextDate),
    dailyBonusBadges: useObservable(popupStateService.dailyBonusBadges),
    triggeredPopupBadges: useObservable(popupStateService.triggeredPopupBadges),
    popupIndexToCollect: useObservable(popupStateService.popupIndexToCollect),
    showFailPopup: useObservable(popupStateService.showFailPopup),
    setPopupOffers: popupStateService.setPopupOffers,
    setCurrentPopupDisplayed: popupStateService.setCurrentPopupDisplayed,
    setDailyBonusBadgesNextDate: popupStateService.setDailyBonusBadgesNextDate,
    setDailyBonusBadges: popupStateService.setDailyBonusBadges,
    setTriggeredPopupBadges: popupStateService.setTriggeredPopupBadges,
    setPopupIndexToCollect: popupStateService.setPopupIndexToCollect,
    setShowFailPopup: popupStateService.setShowFailPopup,
    clear: popupStateService.clear,
  };
};
